import { render, staticRenderFns } from "./JGridAlpha.vue?vue&type=template&id=7e3fe1a0&"
import script from "./JGridAlpha.vue?vue&type=script&lang=js&"
export * from "./JGridAlpha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports